import {OfferVariant} from '@vio/core/src/offer/types/OfferVariant'

export const useOfferHasTag = (offerVariant: OfferVariant) => {
  switch (offerVariant) {
    case OfferVariant.BestDeal:
    case OfferVariant.MemberDeal:
    case OfferVariant.MemberPlusDeal:
    case OfferVariant.Popular:
    case OfferVariant.OnlyOnVio:
    case OfferVariant.GreatDeal:
      return true

    default:
      return false
  }
}
